<template>
  <div
    class="sfCreateBlock"
  >
    <div
      v-if="isError"
      class="header error-block"
    >
      <div class="error-title">
        <BIcon
          class="icon"
          type="error"
        >
          report_problem
        </BIcon>
        <span class="title">{{ $t('callTarget.sfCreate.errorSync') }}</span>
      </div>
      <RouterLink
        class="error-link"
        to="/app/setting/salesforce/salesforce-error-logs"
      >
        {{ $t('general.detail') }}
      </RouterLink>
    </div>
    <div class="header">
      <div class="title">
        {{ $t('callTarget.sfCreate.title') }}
      </div>
      <div class="detail">
        {{ $t('callTarget.sfCreate.detail') }}
      </div>
    </div>
    <div
      class="footer"
    >
      <div
        v-show="sfExecSyncBtn"
        class="exec-sync"
      >
        <BBtn
          v-if="isError"
          size="small"
          type="primary"
          class="sync-btn"
          :disabled="isLoading"
          @click="close"
        >
          <span>
            {{ $t('general.ok') }}
          </span>
        </BBtn>
        <BBtn
          v-else
          size="small"
          type="primary"
          class="sync-btn"
          :disabled="isLoading"
          @click="sfCreate"
        >
          <span v-if="isLoading">
            {{ $t('callTarget.sfCreate.creating') }}
          </span>
          <span v-else>
            {{ $t('callTarget.sfCreate.create') }}
          </span>
        </BBtn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapWaitingActions } from 'vue-wait';
import { mapGetters } from 'vuex';
import Api from '@/api/user';
import { CallTargetApiService } from '@/api/user/resources/call_target';
import { formatShorterDateTime } from '@/utils/date-time';

export default {
  props: {
    sfExecSyncBtn: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    'is-loading',
    'modal-close',
    'synced',
  ],
  data: () => {
    return {
      currentSfRelatedLinkInfo: {
        sfRelatedLinks: [],
        sfSyncedAt: null,
      },
      isLoading: false,
      isError: false,
    };
  },
  computed: {
    ...mapGetters('user', [
      'callTarget',
    ]),
    sfRelatedLinkSyncedAt () {
      return formatShorterDateTime(this.currentSfRelatedLinkInfo.sfSyncedAt);
    },
  },
  methods: {
    ...mapWaitingActions('user', {
      getCallTargetAction: 'getCallTargetWait',
      getLeadHistoriesAction: 'getLeadHistoriesWait',
    }),
    async sfCreate() {
      this.isLoading = true;
      this.$emit('is-loading', this.isLoading);
      const api = new CallTargetApiService();
      const result = await api.callTargetExportSf({ request: { callTargetId: this.callTarget.id } });
      const synced = result.data.synced;

      if (synced) {
        await this.getCallTargetAction({ request: { callTargetId: this.callTarget.id } });
        await this.getLeadHistoriesAction({ callTargetId: this.callTarget.id });
        this.isLoading = false;
        this.$emit('is-loading', this.isLoading);
        this.$emit('modal-close');
      } else {
        this.isError = true;
        this.isLoading = false;
        this.$emit('is-loading', this.isLoading);
      }
    },
    async close() {
      await this.getCallTargetAction({ request: { callTargetId: this.callTarget.id } });
      this.$emit('modal-close');
    },
  },
};
</script>

<style  lang="scss">
  .sfCreateBlock {
    padding: 18px;
    position: relative;
    min-height: 140px;
    .header {
      margin-bottom: 7px !important;
      text-align: center;
      // display: flex;
      // justify-content: center;
      .title {
        margin-left: 6px;
        color: #000000;
        display: block;
        height: 29px;
        font-size: 18px;
      }
      .detail {
        font-size: 14px;
        color: $concrete-dark;
        margin-top: 4px;
      }
    }
    .footer {
      margin-top: 12px;
      display: flex;
      justify-content: center;
      .synced-date {
        p {
          font-size: 12px;
          color: $concrete-dark;
          margin-bottom: 0;
        }
      }
      .exec-sync {
        text-align: right;
        bottom: 8px;
        right: 16px;
        .icon-sync {
          margin-right: 4px;
          transform: rotate(90deg);
        }
      }
    }
    .error-block {
      padding: 12px 16px;
      margin: 2px 0;
      border-radius: 4px;
      background-color: #FFEEEE;
      text-align: center;
      color: #FF6465;
      justify-content: space-between;
      .error-title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .error-link {
        color: #FF6465;
      }
      &.header {
        align-items: center;
        margin-bottom: 7px !important;
        display: flex;
        .icon {
          margin-left: 6px;
        }
        .title {
          margin-left: 6px;
          color: #FF6465;
          display: block;
          font-size: 14px;
        }
      }
    }
  }
</style>
